// extracted by mini-css-extract-plugin
export var actions = "_4i-0";
export var actionsContainer = "_4i-7";
export var border = "_4i-1";
export var childFullHeight = "_4i-e";
export var collapse = "_4i-2";
export var content = "_4i-9";
export var contentChild = "_4i-d";
export var fullscreen = "_4i-b";
export var hasLeftRadius = "_4i-q";
export var headerContainer = "_4i-3";
export var headerRow = "_4i-5";
export var hidePadding = "_4i-a";
export var navCollapsedGap = "_4i-r";
export var noScrollX = "_4i-s";
export var noScrollY = "_4i-t";
export var noTopPadding = "_4i-o";
export var optOutTopPadding = "_4i-c";
export var outletContent = "_4i-k";
export var outletContentInner = "_4i-l";
export var outletLeadingPanel = "_4i-h";
export var outletLeadingPanelAttention = "_4i-i";
export var outletResizeDivider = "_4i-j";
export var outletSplit = "_4i-f";
export var outletSplitResizing = "_4i-g";
export var pageMain = "_4i-p";
export var pageOuter = "_4i-m";
export var pagePadding = "_4i-8";
export var profile = "_4i-u";
export var profileContainer = "_4i-v";
export var profileImage = "_4i-w";
export var profileMain = "_4i-x";
export var profileSubtitle = "_4i-z";
export var profileTitle = "_4i-y";
export var showLeftPadding = "_4i-n";
export var tabsPortalSlot = "_4i-6";
export var tabsWrapper = "_4i-4";
export var title = "_4i-10";